import React from 'react';
import { GiftIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { IMAGES, scrollToPrice } from '../utils/constants';
const BONOS = [{
  title: 'Bono 1 — English Eras (Inglés Inmersivo)',
  desc: 'Mini-unidades con historia: reading + vocab + speaking + writing.',
  img: IMAGES.bono1
}, {
  title: 'Bono 2 — Planner Docente (Mensual + Semanal)',
  desc: 'Organización para planificar más rápido (plantillas duplicables).',
  img: IMAGES.bono2
}, {
  title: 'Bono 3 — Vocab Pack: Daily Routines',
  desc: 'Flashcards + worksheets + speaking + answer key.',
  img: IMAGES.bono3
}];
export function BonosExclusivos() {
  return <section className="pt-20 pb-8 bg-orange-50/70" data-id="element-41">
      <div className="max-w-6xl mx-auto px-4" data-id="element-42">
        <div className="text-center mb-16" data-id="element-43">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 uppercase mb-4" data-id="element-44">
            BONOS EXCLUSIVOS
          </h2>
          <div className="inline-flex items-center justify-center gap-2 bg-yellow-400 text-gray-900 px-6 py-2 rounded-full font-black text-xl md:text-2xl shadow-md" data-id="element-45">
            <GiftIcon className="w-6 h-6" data-id="element-46" />
            🎁 ¡GRATIS POR HOY!
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-47">
          {BONOS.map((bono, index) => <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} key={index} className="bg-white rounded-3xl overflow-hidden shadow-xl border-2 border-orange-100 flex flex-col group" data-id="element-48">
              <div className="relative cursor-pointer overflow-hidden" onClick={scrollToPrice} data-id="element-49">
                <div className="absolute top-4 right-4 bg-red-600 text-white font-black px-4 py-1 rounded-full z-10 shadow-lg transform rotate-3" data-id="element-50">
                  GRATIS
                </div>
                <img src={bono.img} alt={bono.title} className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-51" />
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-52">
                <h3 className="font-black text-xl text-gray-900 mb-3" data-id="element-53">
                  {bono.title}
                </h3>
                <p className="text-gray-600 font-medium flex-1" data-id="element-54">{bono.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}